import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ApiUrl from '../../config/app-config';

const baseURL = ApiUrl();

const FaqList = (props) => {
  const pageName = "문의하기";
  const headerUi = {
    goback: true,
    closeAll: false,
  };

  /**리스트 데이터 받아오기 */
  const [data, setData] = useState();
  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/faq`, {
        params: {
          listSize: 50,
          totalListCount: 4,
          currentPageIndex: 1,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      setData(result)
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);


  /**FAQ 주요안내사항 리스트 */
  const faqImportents =
    data && data.filter((item) => item.state === false); //주요안내 미적용 안내사항 리스트 전체
  const faqBtnList = faqImportents && faqImportents.map((item) => item.faqType); // 타입 전체
  const faqImSet = new Set(faqBtnList); //타입 중복값 제거
  const faqImArr = [...faqImSet]; // 중복값 없는 새 타입 배열 생성

  return (
    <div className="container qna faq">
      <div className="faq_list_wrap">
        <h2 className="font-primary">자주 하는 질문</h2>
        <div className="faq_lists">
          {data &&
            data
              .filter((item) => item.state === true)
              .map((item) => {
                return (
                  <Link
                    to={`/faq/${item.id}`}
                    key={item.id}
                    className="faq_list"
                  >
                    <span className="txt_wrap">
                      <span>[{item.faqType}] </span>
                      <span className="faq_list_txt">{item.question}</span>
                    </span>
                    <img src="./img/Right.svg" alt="상세보기" />
                  </Link>
                );
              })}
        </div>
      </div>
      <div className="faq_btn_wrap">
        <h2 className="font-primary">FAQ</h2>
        <div className="faq_btns">
          {faqImArr.map((i, index) => {
            return (
              <Link
                key={index}
                to={`/faqimport/${i}`}
              >
                {i}
              </Link>
            );
          })}
        </div>
      </div>
      <div className="footer_fix">
        <div className="footer_btn">
          <Link to="/qna" className="qna_list">
            문의 내역
          </Link>
          <Link to="/qna/write" className="qna_write">
            문의 하기
          </Link>
        </div>
      </div>
    </div>
  );
};
export default FaqList;
